<template>
  <div class="template-solicitacao-form-item">
    <div class="template-solicitacao-form-item-content">
      <div class="template-solicitacao-form-item-form">
        <div
          :id="formContainerId"
        />
      </div>
      <div class="template-solicitacao-form-item-trash">
        <div
          style="cursor:pointer;"
          @click="$emit('remover')"
        >
          <svg-icone
            :url="deletarIcone"
            icone="icon_field_delete"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { urlIcons } from '@/utils/ImageBucket'
import { renderForm } from '@mobilesaude/form-builder-sdk'
import { mapGetters } from 'vuex'

export default {
  name: 'EntradaMultiForm',
  props: {
    entrada: {
      type: Object,
      default: () => ({})
    },
    entradaId: {
      type: [Number, String]
    },
    formId: {
      type: [Number, String]
    },
    clientKey: {
      type: String
    }
  },
  data () {
    return {
      formContainerId: '',
      form: null
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['estilo']),
    formBuilderColors () {
      const colors = this.estilo.formBuilder

      if (!colors) {
        return {}
      }

      return {
        primary: colors.corPrincipalFormBuilder,
        errors: colors.corErroFormBuilder,
        alert: colors.corAlertaFormBuilder
      }
    },
    deletarIcone () {
      return urlIcons('icon_field_delete')
    }
  },
  methods: {
    async init () {
      this.form = renderForm({
        identifier: this.formContainerId,
        clientKey: this.clientKey,
        idForm: this.formId,
        readOnly: true,
        json: this.entrada,
        colors: { ...this.formBuilderColors }
      })

      this.form.on('LOADING', res => {
        this.form.showOnly(null, true)
      })
    }
  },
  created () {
    this.formContainerId = `form-view-container-${this.entradaId}`
  },
  mounted () {
    this.init()
  }
}
</script>
